import $ from 'jquery';

$(document).ready(function () {
  featuresWidget();
});

function featuresWidget() {
  $('.features-list-widget__item-list-button').on('click', function () {
    $('.features-list-widget__item-list').removeClass('active-list');
    $(this).next().slideToggle();
    $(this).toggleClass('list-active');
  });
}
